import { ComponentPortal, Portal } from '@angular/cdk/portal';
import { Component, Input, OnChanges, TemplateRef, ViewChild } from '@angular/core';
import { Errors } from './handle-errors.config';
import { ErrorRendered } from '@core/types/error.type';

@Component({
  selector: 'shell-handle-errors',
  templateUrl: './handle-errors.component.html',
  styleUrls: ['./handle-errors.component.scss'],
})
export class HandleErrorsComponent implements OnChanges {
  constructor() {}
  @Input() error: ErrorRendered = '';

  @ViewChild('templatePortalContent') templatePortalContent: TemplateRef<any>;

  selectedPortal: Portal<any>;

  ngOnChanges(): void {
    this.showModal();
  }

  showModal() {
    const errorComponent: any = Errors.get(this.error);
    this.selectedPortal = new ComponentPortal(errorComponent);
  }
}
